import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import routes from './routes';
import workflowsReducer from './workflows/data/reducer';
import workflowsSaga from './workflows/data/sagas';

const reducer = combineReducers({
  workflows: workflowsReducer,
});

const saga = function* () {
  yield all([workflowsSaga()]);
};

export { reducer, saga, routes };
